/* import { AuthStateCookie, getCookie, removeCookie, setCookie } from '@/auth/duck';

 export const makeAuthStateAndSetCookie = (length: number) => {
 let state = '';
 const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
 const charactersLength = characters.length;
 for (let i = 0; i < length; i++) {
 state += characters.charAt(Math.floor(Math.random() * charactersLength));
 }
 setCookie(AuthStateCookie, state, 5);
 return state;
 };

 export const checkAuthStateAndRemoveCookie = (state: string | null): boolean => {
 const originalState = getCookie(AuthStateCookie);
 removeCookie(AuthStateCookie);
 return state === originalState;
 }; */

export const getTokenTimeRemaining = (
  expiresAt: number | null | undefined,
): number | null => {
  if (!expiresAt) {
    return null;
  }

  const now = Date.now();
  const remaining = expiresAt - now;

  return remaining > 0 ? remaining : null;
};

export const shouldRefreshToken = (
  expiresAt: number | null | undefined,
  thresholdMs: number = 60000,
): boolean => {
  const timeRemaining = getTokenTimeRemaining(expiresAt);

  if (!timeRemaining) {
    return true;
  }

  return timeRemaining < thresholdMs;
};